<template>
    <el-dialog :visible="true" :close-on-click-modal="false" :before-close="handleCloseDialog" width="40%" @open="onDialogOpen">
        <div slot="title" class="dialog-header">
            <div class="dialog-title">发票信息</div>
        </div>
        <div class="tips">
            <div class="tips-header">
                <div class="tips-title">温馨提示：</div>
                <div class="countdown" v-if="lockRemaining > 0">阅读倒计时：<span style="color:#F56C6C">{{ lockRemaining }} s</span></div>
            </div>
            <ol class="tips-list">
                <li>请在<span class="red">当日16:30前</span>提交线上申请并审核通过，逾期于次日处理。</li>
                <li>请业务与客户确认<span class="red">是否需要开具明细（抬头限制、单位、数量）</span>，避免作废发票。</li>
                <li>建议客户在以下事项完成后申请开票：<span class="red">1. 过会流程完成；2. 合同签署生效；3. 政府采购项目需在采购流程全部完成（或采购合同签字）后。</span>避免因发票开具时间早于上述节点，不符合自然状况导致发票作废。</li>
            </ol>
        </div>
        <el-form size="small" :model="form" ref="form" :rules="rules" :disabled="is_show || isLocked"  label-width="120px" class="invoice-ruleForm">
            <el-form-item label="发票抬头" prop="title">
                <el-input :disabled="isLocked" placeholder="请输入发票名称" v-model="form.title" class="input_width" @input="onTitleInput" @blur="onTitleBlur"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="taxpayer_id">
                <el-input :disabled="isLocked" placeholder="请输入纳税人识别号" v-model="form.taxpayer_id" class="input_width"></el-input>
            </el-form-item>
            
            <el-form-item label="" prop="contract_seal">
                <el-checkbox v-if="!isFillInvoice" v-model="form.contract_seal" :disabled="isLocked">合同盖章</el-checkbox>
                <el-checkbox v-model="form.apply_open" :disabled="forceApplyOpen || isLocked">申请开票</el-checkbox>
            </el-form-item>
            <template v-if="form.contract_seal">
                <el-form-item label="合同类型" prop="contract_type">
                    <el-select v-model="form.contract_type" placeholder="请选择合同类型" multiple>
                        <el-option v-for="(contract, index) in contract_types" :label="contract.label" :value="contract.value" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="要求处理时间" prop="handle_at">
                    <el-date-picker
                    format="yyyy-M-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    v-model="form.handle_at"
                    placeholder="请选择处理时间">
                    </el-date-picker>
                </el-form-item>
            </template>
            
            <template v-if="form.apply_open">
                <el-form-item label="发票类型"  prop="type">
                    <el-radio-group :disabled="isLocked" v-model="form.type" @change="typeChange">

                        <el-radio :label="3">普通发票(电子)</el-radio>
                        <el-radio :label="4">专用发票(电子)</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="开票内容" prop="content">
                    <el-select :disabled="isLocked" v-model="form.content">
                        <el-option v-for="(type, index) in invoiceTypes" :key="index" :value="type.value" :label="type.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开票金额" prop="total_amount">
                    <el-input type="number" :disabled="isLocked" placeholder="请输入开票金额" v-model="form.total_amount" class="input_width"></el-input>
                </el-form-item>
                <el-form-item label="开票明细">
                    <el-button type="text" @click="openDetailsDialog">+新增明细</el-button>
                    <span class="detail-tag" v-for="(t, i) in detailsTags" :key="i" style="margin-left:8px;">
                        {{ t }}
                        <i class="el-icon-close" @click="removeDetailTag(i)"></i>
                    </span>
                </el-form-item>
                <el-form-item label="开户行" prop="bank_name">
                    <el-input :disabled="isLocked" placeholder="请输入开户行" v-model="form.bank_name" class="input_width"></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="account">
                    <el-input type="number" :disabled="isLocked" placeholder="请输入账号" v-model="form.account" class="input_width"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="mobile">
                    <el-input :disabled="isLocked" placeholder="请输入电话号码" v-model="form.mobile" class="input_width"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                    <el-input :disabled="isLocked" placeholder="请输入地址" v-model="form.address" class="input_width"></el-input>
                </el-form-item>
                <el-form-item label="附件" prop="file_list">
                    <el-upload
                    :disabled="isLocked"
                    class="upload-demo"
                    action="api/common/upload-contract"
                    name="contractFile"
                    :headers="headers"
                    :on-success="uploadSuccess"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :file-list="form.file_list">
                        <el-button type="primary" :disabled="isLocked">点击上传</el-button>
                        <span slot="tip" class="el-upload__tip"> 单个文件最大支持50MB,上传请耐心等待</span>
                    </el-upload>
                </el-form-item>
                <el-form-item label="备注" prop="memo">
                    <el-input :disabled="isLocked" placeholder="请输入备注" v-model="form.memo" class="input_width"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email" v-if="form.type > 2">
                    <el-input :disabled="isLocked" placeholder="请输入邮箱" v-model="form.email" class="input_width"></el-input>
                </el-form-item>
            <el-form-item label="对应订单ID" prop="order_id" v-if="is_need_order_id">
                    <el-input :disabled="isLocked" placeholder="对应订单ID" v-model="form.order_id" class="input_width" @blur="fetchOrderContractAmount"></el-input>
            </el-form-item>
                <el-form-item label="申请开票日期" prop="apply_open_at">
                    <el-date-picker
                    format="yyyy-M-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    v-model="form.apply_open_at"
                    placeholder="选择申请开票日期" :disabled="isLocked">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="Acs('/order/issue')" label="发票开具日期" prop="input_at">
                    <el-date-picker
                    format="yyyy-M-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    v-model="form.input_at"
                    placeholder="选择发票开具日期" :disabled="isLocked">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="Acs('/order/issue')" label="是否开具发票">
                    <el-switch v-model="form.issue" :active-value="1" :inactive-value="0" :disabled="isLocked"></el-switch>
                </el-form-item>
            </template>

            <template v-if="form.contract_seal || form.apply_open">
                <el-form-item label="" prop="is_logistic">
                    <el-checkbox v-model="form.is_logistic" :disabled="isLocked">需要寄件</el-checkbox>
                </el-form-item>
            </template>

            <template v-if="form.is_logistic">
                <el-form-item label="寄出日期" prop="send_at">
                    <el-date-picker
                    format="yyyy-M-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    v-model="form.send_at"
                    placeholder="选择寄出日期"
                    :disabled="isLocked">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="寄件方式：" prop="send_type">
                    <el-radio-group v-model="form.send_type" :disabled="isLocked">
                        <el-radio :label="1">快递</el-radio>
                        <el-radio :label="2">邮件（请备注邮箱）</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="form.send_type == 1"  label="寄件快递：" prop="send_way">
                    <el-select v-model="form.send_way" placeholder="请选择送达方式" :disabled="isLocked" multiple clearable>
                        <el-option label="德邦快递" value="1"></el-option>
                        <el-option label="中通快递" value="2"></el-option>
                        <el-option label="圆通快递" value="3"></el-option>
                        <el-option label="顺丰快递" value="4"></el-option>
                        <el-option label="韵达快递" value="5"></el-option>
                        <el-option label="邮政快递" value="6"></el-option>
                        <el-option label="其他" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="收货地址：" prop="express_id">
                    <OrderAddress :express_id="form.express_id" :order_id="getOrderId()" @change="handleAddressSelect" style="width:60%;" :key="order_address_key" :enableOrderIdCheck="false" :customer_id="computedCustomerId"></OrderAddress>
                    &nbsp;&nbsp;&nbsp;
                    <el-button size="mini" type="text" @click="dialogExpressTable">+新增地址</el-button>
                </el-form-item>
                <el-form-item label="寄件备注：" prop="express_content">
                    <el-input v-model="form.express_content" autocomplete="off" :disabled="isLocked"></el-input>
                </el-form-item>
            </template>
        </el-form>
        <div class="lock-overlay" v-if="isLocked"></div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog" :disabled="isLocked">关闭</el-button>
            <el-button v-if="!is_show" type="primary" @click="handleSubmit" :loading="loading" :disabled="isLocked">保存</el-button>
        </div>
        
        <!-- 地址信息弹框 -->
        <el-dialog 
            title="地址信息" 
            :visible.sync="dialogExpressVisible" 
            width="650px" 
            center 
            :close-on-click-modal="false" 
            :before-close="handleCloseAddressDialog"
            append-to-body
            :modal-append-to-body="false"
            custom-class="address-dialog-wrapper">
            <el-form :model="newAddress" ref="addressForm" :rules="addressRules" class="demo-ruleForm">
                <el-form-item label="收件人姓名" label-width="100px" prop="name">
                    <el-input v-model="newAddress.name" auto-complete="off" placeholder="请输入收件人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" label-width="100px" prop="mobile">
                    <el-input v-model="newAddress.mobile" auto-complete="off" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <DistrictLinkage 
                    :itemLabelWidth="'100px'" 
                    :provinceId="newAddress.province_id"  
                    :cityId="newAddress.city_id" 
                    :districtId="newAddress.district"  
                    @change="handleAddressChange">
                </DistrictLinkage>
                <el-form-item label="地址" label-width="100px" prop="address">
                    <el-input v-model="newAddress.address" auto-complete="off" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="邮寄方式" label-width="100px" prop="express_company">
                    <el-select v-model="newAddress.express_company" placeholder="请选择">
                        <el-option v-for="item in expressOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注信息" label-width="100px">
                    <el-input v-model="newAddress.memo" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseAddressDialog">关闭</el-button>
                <el-button type="primary" @click="handleSubmitAddress" :loading="addressLoading">保存</el-button>
            </div>
        </el-dialog>

        <!-- 开票明细弹框 -->
        <el-dialog 
            title="开票明细"
            :visible.sync="detailsDialogVisible"
            width="700px"
            center
            :close-on-click-modal="false"
            append-to-body
            :modal-append-to-body="false">
            <el-table :data="detailsRows" border style="width: 100%">
                <el-table-column label="* 规格型号（产品名称）">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.product_name" placeholder="请输入规格型号"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="* 单位（年、月、天、台等）" width="200">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.unit" placeholder="请输入单位"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="* 数量（整数/小数）" width="180">
                <template slot-scope="scope">
                    <el-input 
                        v-model="scope.row.num" 
                        placeholder="请输入数量"
                        @input="onDetailNumInput(scope.row)"
                        @blur="validateDetailNum(scope.row, scope.$index)"
                    ></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #F56C6C;" @click="removeDetailRow(scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
            <div style="margin-top:12px;">
                <el-button size="mini" @click="addDetailsRow">新增一行</el-button>
                <el-button size="mini" type="warning" @click="clearDetailsRows">清空</el-button>
            </div>
            <div v-if="detailsError" class="details-error" style="color:#F56C6C;font-size:12px;margin-top:8px;">{{ detailsError }}</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="confirmDetails(false)">关闭</el-button>
                <el-button type="primary" @click="confirmDetails(true)">保存</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<style>
/* 只针对地址弹框设置更高的 z-index */
.address-dialog-wrapper {
    z-index: 3000 !important;
}

.address-dialog-wrapper .el-dialog {
    z-index: 3000 !important;
}
.dialog-header { display: flex; justify-content: center; align-items: center; }
.dialog-title { font-weight: 600; font-size: 18px; text-align: center; flex: 1; }
.tips-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.countdown { font-size: 14px; color: #303133; font-weight: bold; }
.tips-title { font-weight: 600; }
.tips-list { padding-left: 18px; margin: 0 0 12px 0; }
.red { color: #F56C6C; }
.el-dialog__body { position: relative; }
.lock-overlay { position: absolute; inset: 0; background: transparent; z-index: 10; pointer-events: all; cursor: not-allowed; }
.overlay-text { display: none; }
.detail-tag { display:inline-flex; align-items:center; padding:2px 6px; margin-left:8px; background:#f5f7fa; border-radius:12px; color:#606266; }
.detail-tag i { font-size:12px; margin-left:6px; cursor:pointer; }
</style>
<script>
    import OrderService from '~/services/order';
    import OrderContractSealService from "~/services/OrderContractSeal";
    import OrderExpressService from '~/services/OrderExpress';
    import {Regexp} from "~/config/params";
    import Params from "~/config/params";
    import OrderAddress from "~/widgets/OrderAddress.vue";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";


    export default {
        components: {
            OrderAddress,
            DistrictLinkage
        },
        data() {
            var checkInvoiveFee = (rule, value, callback) => {
                if (value === '' || value === null || typeof value === 'undefined') {
                    return callback(new Error('开票金额不能为空'));
                }
                const amountText = String(value).trim();
                if (!/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(amountText)) {
                    return callback(new Error('开票金额格式不正确，请输入最多保留两位小数的有效数字'));
                }
                const amount = Number(amountText);
                if (!(amount > 0)) {
                    return callback(new Error('开票金额必须大于0'));
                }
                const contractAmount = this.getContractAmount();
                const remainAmount = this.getRemainInvoiceAmount();
                if (remainAmount !== null && Math.round(amount * 100) > Math.round(remainAmount * 100)) {
                    return callback(new Error('本次开票金额已超出订单合同金额（合同金额为 ' + this.formatMoney(contractAmount) + ' 元，剩余可开票 ' + this.formatMoney(remainAmount) + ' 元），请调整开票金额'));
                }
                callback();
            };
            var checkTaxpayerId = (rule, value, callback) => {
                if (value === '' || value === null || typeof value === 'undefined' || String(value).trim() === '') {
                    return callback();
                }
                const taxpayerId = String(value).trim();
                const length = taxpayerId.length;
                if (length !== 15 && length !== 18 && length !== 20) {
                    return callback(new Error('纳税人识别号长度不符合要求，请检查后重新输入'));
                }
                callback();
            };
            var checkAccount = (rule, value, callback) => {
                if (value === '' || value === null || typeof value === 'undefined') {
                    return callback();
                }
                const account = String(value).trim();
                if (!account) {
                    return callback();
                }
                if (!/^\d+$/.test(account)) {
                    return callback(new Error('请输入正确的账号'));
                }
                callback();
            };
            var checkMobile = (rule, value, callback) => {
                if (value === '' || value === null || typeof value === 'undefined') {
                    return callback();
                }
                const mobile = String(value).trim();
                if (!mobile) {
                    return callback();
                }
                if (Regexp.phone_number.test(mobile) || Regexp.mobile.test(mobile)) {
                    return callback();
                }
                callback(new Error('请输入正确的手机号或电话号码'));
            };
            var checkNoSpace = (rule, value, callback) => {
                if (value === '' || value === null || typeof value === 'undefined') {
                    return callback();
                }
                if (/\s/.test(String(value))) {
                    return callback(new Error('请勿输入空格'));
                }
                callback();
            };


            return {
                isLocked: false,
                lockRemaining: 0,
                lockTimer: null,
                loading: false,
                detailsDialogVisible: false,
                detailsRows: [
                    { product_name: '', unit: '', num: '' },
                    { product_name: '', unit: '', num: '' }
                ],
                detailsError: '',
                detailsTags: [],
                detailsMarker: '[DETAILS]',
                orderContractAmount: null,
                orderInvoices: null,
                rules: {
                    type: [
                        {
                            required: true,
                            message: "请选择发票类型",
                            trigger: "blur"
                        }
                    ],
                    title: [
                        {
                            required: true,
                            message: "请输入发票抬头",
                            trigger: "blur"
                        },
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        }
                    ],
                    input_at: [
                        {
                            required: false,
                            message: "请选择开票日期",
                            trigger: "blur"
                        }
                    ],
                    order_id: [
                        {
                            required: true,
                            message: "请填写对应订单ID",
                            trigger: "blur"
                        },
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        }
                    ],
                    content: [
                        {
                            required: true,
                            message: "请选择发票内容",
                            trigger: "blur"
                        }
                    ],
                    total_amount: [
                        {
                            required: true,
                            validator: checkInvoiveFee,
                            trigger: "blur"
                        },
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        }
                    ],
                    taxpayer_id: [
                        {
                            required: true,
                            message: "请输入纳税人识别号",
                            trigger: "blur"
                        },
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        },
                        {
                            validator: checkTaxpayerId,
                            trigger: "blur"
                        }
                    ],
                    apply_open_at: [{required: true, message: "请选择申请开票日期", trigger: "change"}],
                    contract_type: [{required: true, message: "请选择合同类型", trigger: "change"}],
                    handle_at: [{required: true, message: "请选择合同处理时间", trigger: "change"}],
                    bank_name: [
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        }
                    ],
                    address: [
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        }
                    ],
                    memo: [
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        }
                    ],
                    account: [
                        {
                            required: false,
                            validator: checkNoSpace,
                            trigger: "blur"
                        },
                        {
                            required: false,
                            validator: checkAccount,
                            trigger: "blur"
                        }
                    ],
                    mobile: [
                        {
                            required: false,
                            validator: checkNoSpace,
                            trigger: "blur"
                        },
                        {
                            required: false,
                            validator: checkMobile,
                            trigger: "blur"
                        }
                    ],
                    email: [
                        {
                            required: true,
                            type: 'email', message: '请输入正确的邮箱地址',
                            trigger: "blur"
                        },
                        {
                            validator: checkNoSpace,
                            trigger: "blur"
                        }
                    ],
                    send_at: [
                        {required: true, message: '请填选寄出日期', trigger: 'change'},
                    ],
                    send_type: [
                        {required: true, message: '请填选送达方式', trigger: 'change'},
                    ],
                    send_way: [
                        {required: true, message: '请选择寄件快递', trigger: 'change'},
                    ],
                    express_id: [
                        {required: true, message: '请选择收货地址', trigger: 'change'},
                    ],
                },
                invoiceTypes: [],
                headers: {
                    "access-token": this.$store.getters.token
                },
                form: {
                    id: "",
                    type: 3,
                    title: "",
                    content: [],
                    total_amount: "",
                    input_at: "",
                    taxpayer_id: "",
                    bank_name: "",
                    account: "",
                    mobile:"",
                    email:"",
                    address:"",
                    file_list:[],
                    order_id:'',
                    memo:'',
                    issue: 0,
                    sender: this.$store.getters.name,//寄件人
                    contract_type: [],
                    handle_at: '',
                    apply_open_at: '',
                    contract_seal: false,
                    apply_open: false,
                    is_logistic: false,
                    send_at: '',
                    send_type: '',
                    send_way: [],
                    express_content: '',
                    express_id: '', // 收货地址ID
                },
                dialogExpressVisible: false,
                addressLoading: false,
                newAddress: {
                    name: '',
                    mobile: '',
                    address: '',
                    memo: '',
                    express_company: '',
                    province_id: 0,
                    city_id: 0,
                    district: 0,
                    label_name: ''
                },
                addressRules: {
                    name: [
                        { required: true, message: '请输入收件人姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入联系方式', trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: '请输入详细地址', trigger: 'blur' }
                    ],
                    express_company: [
                        { required: true, message: '请选择邮寄方式', trigger: 'blur' }
                    ],
                    province_id: [
                        { required: true, message: '请选择所在地区', trigger: 'change' }
                    ],
                    city_id: [
                        { required: true, message: '请选择所在地区', trigger: 'change' }
                    ],
                    district: [
                        { required: true, message: '请选择所在地区', trigger: 'change' }
                    ]
                },
                expressOptions: [],
                order_address_key: 1,
                contract_types: OrderContractSealService.contractTypes()
            }
        },
        props: {
            invoiceForm: null,
            is_need_order_id:false,
            is_show:false,//仅展示,不能编辑
            is_edit:false,//仅编辑
            isFillInvoice: false,//新增参数
            forceApplyOpen: false,//强制选中申请开票且不可更改
            customer_id: {
                type: [Number, String],
                default: null
            },
            contractAmount: {
                type: [Number, String],
                default: null
            },
            invoices: {
                type: Array,
                default() {
                    return [];
                }
            }
        },

        computed: {
            computedCustomerId() {
                return this.customer_id || 
                       this.$route.query.customer_id || 
                       this.$route.params.customer_id ||
                       (this.invoiceForm && this.invoiceForm.customer_id);
            },
            isFillInvoiceMode() {
                return (this.$route.query && this.$route.query.type == Params.FILL_INVOICE) || this.isFillInvoice;
            }
        },

        watch: {
            // 监听地址弹框状态变化
            dialogExpressVisible(newVal) {
                if (!newVal) {
                    // 弹框关闭时重置数据
                    this.$nextTick(() => {
                        if (this.$refs.addressForm) {
                            this.$refs.addressForm.resetFields();
                        }
                    });
                }
            }
        },

        created() {
            var is_delete = [0];
            if (this.invoiceForm) {
                this.form = Object.assign(this.form, this.invoiceForm);
            }
            // this.form.content = this.form.content ? parseInt(this.form.content) : '';

            if (this.is_show){
                is_delete = [0, 1];
            }
            
            // 检查是否为补充发票类型（从路由或props）
            if ((this.$route.query && this.$route.query.type == Params.FILL_INVOICE) || this.isFillInvoice) {
                // 如果是补充发票类型，自动选中申请开票
                this.form.apply_open = true;
                // 重置合同盖章选项
                this.form.contract_seal = false;
            }
            
            // 如果强制选中申请开票且不可更改
            if (this.forceApplyOpen) {
                this.form.apply_open = true;
            }
            
            OrderService.myInvoiceContext(is_delete).then(res => {
              this.invoiceTypes = res.data;
            });
            
            // 初始化快递选项
            this.expressOptions = OrderService.options();
            console.log('发票信息：', this.invoiceForm);
            this.hydrateDetailsFromForm();
            this.fetchOrderContractAmount();
        },
        mounted() {
            this.$nextTick(() => {
                this.startLock();
            });
        },
        methods: {
            handleCloseDialog() {
                this.clearLock();
                this.$emit("handleAddInvoice");
            },
            onDialogOpen() {
                this.startLock();
            },
            startLock() {
                if (this.is_show || this.is_edit) return;
                if (this.lockTimer) return;
                this.isLocked = true;
                this.lockRemaining = 3;
                clearInterval(this.lockTimer);
                this.lockTimer = setInterval(() => {
                    if (this.lockRemaining > 1) {
                        this.lockRemaining -= 1;
                    } else {
                        this.isLocked = false;
                        this.lockRemaining = 0;
                        clearInterval(this.lockTimer);
                        this.lockTimer = null;
                    }
                }, 1000);
            },
            clearLock() {
                clearInterval(this.lockTimer);
                this.lockTimer = null;
                this.isLocked = false;
                this.lockRemaining = 0;
            },
            openDetailsDialog() {
                this.detailsDialogVisible = true;
                this.detailsError = '';
            },
            onTitleInput() {
                this.form.title = String(this.form.title || '').replace(/^\s+/, '');
            },
            onTitleBlur() {
                this.form.title = String(this.form.title || '').replace(/^\s+/, '');
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.validateField('title');
                    }
                });
            },
            getContractAmount() {
                if (this.orderContractAmount !== null && this.orderContractAmount !== undefined && this.orderContractAmount !== '') {
                    const amount = Number(this.orderContractAmount);
                    return isNaN(amount) ? null : amount;
                }
                if (this.contractAmount !== null && this.contractAmount !== undefined && this.contractAmount !== '') {
                    const amount = Number(this.contractAmount);
                    return isNaN(amount) ? null : amount;
                }
                return null;
            },
            formatMoney(value) {
                const amount = Number(value);
                if (isNaN(amount)) {
                    return value;
                }
                return (Math.round(amount * 100) / 100).toString();
            },
            getInvoiceList() {
                if (this.orderInvoices) {
                    return this.orderInvoices;
                }
                return this.invoices || [];
            },
            isVoidedInvoice(item) {
                return item && (item.is_delete == 1 || item.is_delete === true || item.is_delete == '1');
            },
            getInvoicedAmount() {
                const currentId = this.form.id || (this.invoiceForm && this.invoiceForm.id);
                return this.getInvoiceList().reduce((sum, item) => {
                    if (!item || this.isVoidedInvoice(item)) {
                        return sum;
                    }
                    if (currentId && item.id == currentId) {
                        return sum;
                    }
                    return sum + (parseFloat(item.total_amount) || 0);
                }, 0);
            },
            getRemainInvoiceAmount() {
                const contractAmount = this.getContractAmount();
                if (contractAmount === null) {
                    return null;
                }
                return Math.round((contractAmount - this.getInvoicedAmount()) * 100) / 100;
            },
            fetchOrderContractAmount() {
                const orderId = this.form.order_id || this.getOrderId();
                if (!orderId) {
                    return;
                }
                OrderService.getDetail(orderId).then(res => {
                    if (res && res.code == 0 && res.data) {
                        let amount = null;
                        if (res.data.finance && res.data.finance.total_amount !== undefined && res.data.finance.total_amount !== null && res.data.finance.total_amount !== '') {
                            amount = res.data.finance.total_amount;
                        } else if (res.data.total_amount !== undefined && res.data.total_amount !== null && res.data.total_amount !== '') {
                            amount = res.data.total_amount;
                        }
                        this.orderContractAmount = amount === null ? null : Number(amount);
                        this.orderInvoices = (res.data.finance && res.data.finance.invoice) ? res.data.finance.invoice : [];
                        if (this.$refs.form && this.form.total_amount !== '' && this.form.total_amount !== null) {
                            this.$refs.form.validateField('total_amount');
                        }
                    }
                }).catch(() => {});
            },
            onDetailNumInput(row) {
                let value = row.num === null || typeof row.num === 'undefined' ? '' : String(row.num);
                value = value.replace(/[^\d.]/g, '');
                const parts = value.split('.');
                if (parts.length > 2) {
                    value = parts[0] + '.' + parts.slice(1).join('');
                }
                row.num = value;
            },
            isValidQuantity(num) {
                const value = String(num).trim();
                if (!/^(?:0|[1-9]\d*)(?:\.\d+)?$/.test(value)) {
                    return false;
                }
                return Number(value) > 0;
            },
            validateDetailNum(row, index) {
                const num = (row.num || '').toString().trim();
                if (!num) {
                    return;
                }
                if (!this.isValidQuantity(num)) {
                    this.detailsError = '第' + (index + 1) + '行：数量格式不正确，请输入整数或小数';
                    return;
                }
                if (this.detailsError && this.detailsError.indexOf('数量格式') !== -1) {
                    this.detailsError = '';
                }
            },
            addDetailsRow() {
                this.detailsRows.push({ product_name:'', unit:'', num:'' });
            },
            clearDetailsRows() {
                this.detailsRows = [{ product_name:'', unit:'', num:'' }, { product_name:'', unit:'', num:'' }];
            },
            removeDetailRow(index) {
                this.detailsRows.splice(index, 1);
            },
            removeDetailTag(i) {
                // Find the i-th valid row in detailsRows to remove correct item even if there are empty rows
                let validCount = 0;
                let indexToRemove = -1;
                for (let j = 0; j < this.detailsRows.length; j++) {
                    const r = this.detailsRows[j];
                    if ((r.product_name||'').toString().trim() && (r.unit||'').toString().trim() && (r.num||'').toString().trim()) {
                        if (validCount === i) {
                            indexToRemove = j;
                            break;
                        }
                        validCount++;
                    }
                }
                if (indexToRemove !== -1) {
                    this.detailsRows.splice(indexToRemove, 1);
                    const validRows = this.getValidDetailsRows();
                    this.detailsTags = validRows.map(r => `${r.product_name}-${r.unit}-${r.num}`);
                } else {
                    this.detailsTags.splice(i, 1);
                }
            },
            confirmDetails(save) {
                if (save) {
                    this.detailsError = '';
                    let hasEmpty = false;
                    const emptyRows = [];
                    this.detailsRows.forEach((row, index) => {
                        const product_name_raw = (row.product_name || '').toString();
                        const unit_raw = (row.unit || '').toString();
                        const num_raw = (row.num || '').toString();
                        const product_name = product_name_raw.trim();
                        const unit = unit_raw.trim();
                        const num = num_raw.trim();
                        if (product_name_raw || unit_raw || num_raw) {
                            if (/\s/.test(product_name_raw)) {
                                emptyRows.push(`第${index+1}行：规格型号请勿输入空格`);
                                hasEmpty = true;
                            } else if (!product_name) {
                                emptyRows.push(`第${index+1}行：规格型号`);
                                hasEmpty = true;
                            }
                            if (/\s/.test(unit_raw)) {
                                emptyRows.push(`第${index+1}行：单位请勿输入空格`);
                                hasEmpty = true;
                            } else if (!unit) {
                                emptyRows.push(`第${index+1}行：单位`);
                                hasEmpty = true;
                            }
                            if (/\s/.test(num_raw)) {
                                emptyRows.push(`第${index+1}行：数量请勿输入空格`);
                                hasEmpty = true;
                            } else if (!num) {
                                emptyRows.push(`第${index+1}行：数量`);
                                hasEmpty = true;
                            } else if (!this.isValidQuantity(num)) {
                                emptyRows.push(`第${index+1}行：数量格式不正确`);
                                hasEmpty = true;
                            }
                        }
                    });
                    if (hasEmpty) {
                        this.detailsError = emptyRows.some(item => item.indexOf('格式') !== -1 || item.indexOf('空格') !== -1)
                            ? emptyRows.join('、')
                            : '请填写完整的明细信息：' + emptyRows.join('、');
                        return;
                    }
                    const validRows = this.getValidDetailsRows();
                    this.detailsRows = validRows;
                    this.detailsTags = validRows.map(r => `${r.product_name}-${r.unit}-${r.num}`);
                    this.detailsDialogVisible = false;
                } else {
                    this.detailsDialogVisible = false;
                }
            },
            getValidDetailsRows() {
                return this.detailsRows
                    .filter(r => (r.product_name||'').toString().trim() && (r.unit||'').toString().trim() && (r.num||'').toString().trim())
                    .map(r => ({ product_name: String(r.product_name).trim(), unit: String(r.unit).trim(), num: String(r.num).trim() }));
            },
            hydrateDetailsFromForm() {
                let rows = [];
                if (this.invoiceForm && this.invoiceForm.details && this.invoiceForm.details.length) {
                    rows = this.invoiceForm.details;
                } else if (this.invoiceForm && this.invoiceForm.open_details && this.invoiceForm.open_details.length) {
                    rows = this.invoiceForm.open_details.map(s => {
                        const parts = String(s).split('-');
                        return { product_name: parts[0] || '', unit: parts[1] || '', num: parts[2] || '' };
                    });
                } else if (this.invoiceForm && this.invoiceForm.memo) {
                    const memo = String(this.invoiceForm.memo);
                    if (memo.includes(this.detailsMarker)) {
                        const start = memo.indexOf(this.detailsMarker);
                        const jsonStr = memo.substring(start + this.detailsMarker.length).trim();
                        try {
                            const parsed = JSON.parse(jsonStr);
                            if (Array.isArray(parsed)) rows = parsed;
                        } catch(e) {}
                    } else {
                        // 兼容旧数据：备注末尾直接存放 JSON 数组
                        const lbi = memo.lastIndexOf('[');
                        const rbi = memo.lastIndexOf(']');
                        if (lbi !== -1 && rbi !== -1 && rbi > lbi) {
                            const jsonStr = memo.substring(lbi, rbi + 1);
                            try {
                                const parsed = JSON.parse(jsonStr);
                                if (Array.isArray(parsed)) rows = parsed;
                            } catch(e) {}
                        }
                    }
                }
                if (rows.length) {
                    this.detailsRows = rows.map(r => ({ product_name: r.product_name || r.model || '', unit: r.unit || '', num: r.num || r.qty || '' }));
                    this.detailsTags = this.detailsRows
                        .filter(r => r.product_name && r.unit && r.num !== '')
                        .map(r => `${r.product_name}-${r.unit}-${r.num}`);
                }
                // 清理备注中的明细标记，避免在输入框展示
                const originalMemo = (this.invoiceForm && this.invoiceForm.memo) || this.form.memo || '';
                this.form.memo = this.sanitizeMemo(originalMemo);
            },
            buildMemoWithDetails(baseMemo) {
                const clean = (baseMemo || '').replace(new RegExp(`\n?${this.detailsMarker}.*$`), '');
                const valid = this.getValidDetailsRows();
                if (valid.length) {
                    return `${clean}\n${this.detailsMarker}${JSON.stringify(valid)}`.trim();
                }
                return clean;
            },
            sanitizeMemo(baseMemo) {
                let memo = (baseMemo || '');
                // 去掉带标记的数据
                  memo = memo.replace(/\n?$$DETAILS$$.*$/, '');
                // 兼容旧数据：如果备注末尾是 JSON 数组（且包含 model/unit/qty），移除该数组
                const lbi = memo.lastIndexOf('[');
                const rbi = memo.lastIndexOf(']');
                if (lbi !== -1 && rbi !== -1 && rbi > lbi) {
                    const jsonStr = memo.substring(lbi, rbi + 1);
                    try {
                        const parsed = JSON.parse(jsonStr);
                        if (Array.isArray(parsed) && parsed.some(x => x && (x.model !== undefined || x.unit !== undefined || x.qty !== undefined))) {
                            memo = memo.substring(0, lbi).trim();
                        }
                    } catch(e) {}
                }
                // 清理任意位置可能遗留的单个中文/英文方括号
                memo = memo
                    .replace(/^\s*[\[【]\s*$/,'')              // 仅括号的整行
                    .replace(/^[\[【]/,'')                     // 开头括号
                    .replace(/[\]】]\s*$/,'')                 // 结尾的 ] 或 】
                    .replace(/[\[【]\s*$/,'')                 // 结尾的 [ 或 【（旧数据）
                    .replace(/[\n\r]+$/,'');                  // 结尾换行
                return memo;
            },
            handleSubmit() {
                this.$refs["form"].validate(valid => {
                    this.loading = true;
                    let post_form = {
                        id: this.invoiceForm ? this.invoiceForm.id : '',
                        order_id: this.form.order_id,
                        title: this.form.title,
                        taxpayer_id: this.form.taxpayer_id,
                        sender: this.$store.getters.name,//寄件人
                    };
                    
                    if(this.form.contract_seal){
                        post_form['contract_seal'] = this.form.contract_seal;
                        post_form['contract'] = {
                            type: this.form.contract_type,
                            handle_at: this.form.handle_at
                        };
                        post_form['contract_type'] = this.form.contract_type;
                        post_form['handle_at'] = this.form.handle_at;
                    }

                    if(this.form.apply_open){
                        post_form['apply_open'] = this.form.apply_open;
                        post_form['type'] = this.form.type;
                        post_form['content'] = this.form.content;
                        post_form['total_amount'] = this.form.total_amount;
                        const validDetails = this.getValidDetailsRows();
                        if (this.detailsTags && this.detailsTags.length) {
                            post_form['open_details'] = this.detailsTags;
                        }
                        if (validDetails.length) {
                            post_form['detail'] = validDetails; // 后端字段
                        }
                        post_form['apply_open_at'] = this.form.apply_open_at;
                        post_form['input_at'] = this.form.input_at;
                        post_form['issue'] = this.form.issue;
                        post_form['bank_name'] = this.form.bank_name;
                        post_form['account'] = this.form.account;
                        post_form['mobile'] = this.form.mobile;
                        post_form['address'] = this.form.address;
                        post_form['file_list'] = this.form.file_list;
                        post_form['memo'] = this.sanitizeMemo(this.form.memo);
                        post_form['email'] = '';
                        if (this.form.type > 2) {
                            // 只有电子发票需要填写邮箱
                            post_form['email'] = this.form.email;
                        }
                    }

                    if(this.form.is_logistic){
                        post_form['is_logistic'] = this.form.is_logistic;
                        post_form['logistic'] = {
                            send_at: this.form.send_at,
                            send_type: this.form.send_type,
                            send_way: this.form.send_way,
                            express_content: this.form.express_content,
                            express_id: this.form.express_id
                        };
                        post_form['send_at'] = this.form.send_at;
                        post_form['send_type'] = this.form.send_type;
                        post_form['send_way'] = this.form.send_way;
                        post_form['express_content'] = this.form.express_content;
                        post_form['express_id'] = this.form.express_id;
                    }

                    console.log('handleAddInvoice4: ', post_form, this.form);
                    console.log('收货地址ID: ', this.form.express_id, typeof this.form.express_id);
                    if (this.form.is_logistic) {
                        console.log('寄件信息: ', {
                            express_id: this.form.express_id,
                            send_type: this.form.send_type,
                            send_way: this.form.send_way,
                            express_content: this.form.express_content
                        });
                    }
                    if (valid) {
                        this.$emit("handleAddInvoice", post_form);
                    } else {
                        this.loading = false;
                        return false;
                    }
                });
            },
            handleRemove(file, fileList) {
                this.form.file_list = this.form.file_list.filter(function (item) {
                    return item.uid != file.uid;
                });
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            handlePreview(file) {
                window.open(file.url);
            },
            uploadSuccess(response, file, fileList) {
                if (response.code > 0) {
                    this.$message({
                        message: response.msg,
                        type: 'error'
                    });
                    this.form.file_list = this.form.file_list.filter(function (item) {
                        return item.uid != file.uid;
                    });
                } else {
                    if(this.form.file_list instanceof Array){
                        this.form.file_list.push({
                            "name": response.data.file_name,
                            "url": response.data.file_path,
                            'id': response.data.id
                        });
                    }else{
                        this.form.file_list = [];
                    }

                }
            },

            typeChange(val){
                console.log('类型切换：', val);
            },

            // 获取订单ID
            getOrderId() {
                // 尝试从多个来源获取订单ID
                return this.form.order_id || 
                       (this.invoiceForm && this.invoiceForm.order_id) || 
                       this.$route.query.order_id || 
                       this.$route.params.order_id || 
                       0;
            },

            // 处理地址选择
            handleAddressSelect(value) {
                this.form.express_id = value;
            },

            // 打开地址弹框
            dialogExpressTable() {
                // 确保弹框状态为false，然后设置为true
                this.dialogExpressVisible = false;
                this.$nextTick(() => {
                    this.newAddress = {
                        name: '',
                        mobile: '',
                        address: '',
                        memo: '',
                        express_company: '',
                        province_id: 0,
                        city_id: 0,
                        district: 0,
                        label_name: ''
                    };
                    this.dialogExpressVisible = true;
                });
            },

            // 处理地区选择变化
            handleAddressChange(value) {
                this.newAddress.province_id = parseInt(value[0]);
                this.newAddress.city_id = parseInt(value[1]);
                this.newAddress.district = parseInt(value[2]);
            },

            // 关闭地址弹框
            handleCloseAddressDialog() {
                this.dialogExpressVisible = false;
                // 重置表单
                this.$nextTick(() => {
                    if (this.$refs.addressForm) {
                        this.$refs.addressForm.resetFields();
                    }
                });
                // 重置地址数据
                this.newAddress = {
                    name: '',
                    mobile: '',
                    address: '',
                    memo: '',
                    express_company: '',
                    province_id: 0,
                    city_id: 0,
                    district: 0,
                    label_name: ''
                };
            },

            // 提交地址表单
            handleSubmitAddress() {
                this.$refs.addressForm.validate((valid) => {
                    if (valid) {
                        this.addressLoading = true;
                        
                        // 尝试从多个来源获取 customer_id
                        let customer_id = this.computedCustomerId;
                        
                        console.log('获取到的 customer_id:', customer_id);
                        console.log('路由参数:', this.$route.query);
                        console.log('invoiceForm:', this.invoiceForm);
                        
                        let addressData = {
                            ...this.newAddress,
                            order_id: this.getOrderId(),
                            customer_id: customer_id
                        };
                        
                        OrderExpressService.create(addressData).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '地址添加成功',
                                    type: 'success'
                                });
                                // 设置新添加的地址为选中状态
                                this.form.express_id = res.data.id;
                                // 刷新地址组件
                                this.order_address_key++;
                                this.handleCloseAddressDialog();
                                this.$emit('success-address'); // 触发事件通知父组件刷新
                            } else {
                                this.$message({
                                    message: res.msg || '添加地址失败',
                                    type: 'error'
                                });
                            }
                            this.addressLoading = false;
                        }).catch(err => {
                            console.error(err);
                            this.$message({
                                message: '添加地址失败',
                                type: 'error'
                            });
                            this.addressLoading = false;
                        });
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/invoiceTable.vue